import { SimpleForm, Create } from "react-admin";

import { CreateToolbar } from "../../common/CreateToolbar";
import { ContentTypeSimpleFormContent } from "./components/ContentTypeSimpleFormContent";

export function ContentTypeCreate(): JSX.Element {
    return (
        <Create>
            <SimpleForm defaultValues={{ publicationDate: new Date() }} toolbar={<CreateToolbar />}>
                <ContentTypeSimpleFormContent />
            </SimpleForm>
        </Create>
    );
}
